import { DateFormat } from "../components/DateFormat";
import { CacheableDataObject } from "./CacheableDataObject";

export default class Subscription extends CacheableDataObject {
	isGifted() {
		return this.gifted_from && this.gifted_from !== this.user;
	}
}
Subscription.prototype.dataLocationParsers = {
	end_date: (latestSubscription, data) => {
		latestSubscription.end_date = DateFormat.momentFromLadderTime(data.end_date.timestamp);
	},
	gifted_from: (latestSubscription, data) => {
		latestSubscription.gifted_from = Users.update(data.gifted_from);
	}
};